export const BRAND_COLORS = {
  red: "#EF2D2D",
  orange: "#F4944E",
  blue: "#2B7FE0",
  green: "#9AAD17",
  purple: "#7B6AE8",
  cyan: "#00F0C8",
  dark: "#0A0A0F",
  darker: "#050508",
  cream: "#F5F3EE",
  gray: "#888",
};

// Mycelial signal palette (from design reference doc)
export const MYCELIAL = {
  sporeGold: "#C4A265",
  enzymeAmber: "#A67C52",
  tipGreen: "#6B8F5E",
  networkBlue: "#5B7B8A",
  fruitingCoral: "#B8705A",
  deepSoil: "#1A1714",
  richEarth: "#2C2520",
  warmBark: "#3D332B",
  hyphalCream: "#E8DFD0",
  myceliumWhite: "#F5F0E8",
};
